import { render, staticRenderFns } from "./aktivitaspmb.vue?vue&type=template&id=43f0f637&scoped=true&"
import script from "./aktivitaspmb.vue?vue&type=script&lang=js&"
export * from "./aktivitaspmb.vue?vue&type=script&lang=js&"
import style0 from "./aktivitaspmb.vue?vue&type=style&index=0&id=43f0f637&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f0f637",
  null
  
)

export default component.exports